import styles from "./AppHeader.module.scss";
import { HeadSearch } from "../enhancedSearch/HeadSearch/HeadSearch";
import { useNavigate, useLocation } from "react-router-dom";
import useScreenSize from "../../hooks/useScreenSize";
import useAppModernisation from "../../hooks/useAppModernisation";

const AppHeader = () => {
  const push = useNavigate();
  const { isDesktop } = useScreenSize();
  const hookResult = useAppModernisation() || {};
  const { isAppMode } = hookResult;
  const location = useLocation();

  return (
    <div className={styles.appHeader}>
      <HeadSearch
        classicView={true}
        {...{
          push,
          isDesktop,
          isAppMode,
          searchQuery: location.search,
        }}
      />
    </div>
  );
};

export default AppHeader;
